// extracted by mini-css-extract-plugin
module.exports = {"header":"SessionList_header__KLbQp","card":"SessionList_card__1y0XQ","content":"SessionList_content__2RzxT","table":"SessionList_table__1NLyU"};